import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const IMG_1 =
  "https://customer-assets-agu9un31.emergentagent.net/job_lamp-shop-10/artifacts/d5fb05a8dc8f094b_Captura%20de%20pantalla%202026-10-06%20a%20la%28s%29%202.07.17%E2%80%AFp.m..png";
const IMG_2 =
  "https://customer-assets-agu9un31.emergentagent.net/job_lamp-shop-10/artifacts/6462163caf9c8b7f_Captura%20de%20pantalla%202026-10-06%20a%20la%28s%29%202.06.57%E2%80%AFp.m..png";

const STATS = [
  { value: "2700K", label: "Temperatura cálida estándar" },
  { value: "1 año", label: "Garantía en cada pieza" },
  { value: "100%", label: "Envío en balanza cero" },
];

export const Editorial = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [40, -40]);
  const y2 = useTransform(scrollYProgress, [0, 1], [80, -60]);

  return (
    <section ref={ref} data-testid="editorial-section" className="mx-auto max-w-7xl px-6 py-28">
      <div className="grid items-center gap-16 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-amber-700/80 dark:text-amber-400/90">
            Nuestra filosofía
          </p>
          <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-stone-900 dark:text-stone-50 sm:text-4xl lg:text-5xl">
            La luz no ilumina espacios.
            <span className="block italic text-amber-700 dark:text-amber-400">Ilumina momentos.</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-stone-600 dark:text-stone-300">
            Cada lámpara Hylasu nace en nuestro taller como una escultura: latón cepillado a mano,
            vidrio soplado en pequeñas series y cerámica natural. Diseñamos para el atardecer,
            para la lectura lenta, para la calma.
          </p>
          <p className="mt-5 max-w-md text-base leading-relaxed text-stone-600 dark:text-stone-300">
            Llevamos <span className="font-semibold text-stone-900 dark:text-stone-50">más de 30 años</span> en
            el mundo de la iluminación en México, trabajando con marcas como:
          </p>
          <div className="mt-4 flex flex-wrap gap-2.5">
            {["Costco", "Home Depot", "Casa de las Lomas", "Gaia"].map((brand) => (
              <span
                key={brand}
                className="rounded-full border border-stone-300 px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-stone-600 dark:border-stone-700 dark:text-stone-300"
              >
                {brand}
              </span>
            ))}
          </div>
          <div className="mt-10 grid grid-cols-3 gap-6">
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
              >
                <p className="font-serif text-2xl text-stone-900 dark:text-stone-50 sm:text-3xl">{s.value}</p>
                <p className="mt-1 text-xs text-stone-500 dark:text-stone-400">{s.label}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
        <div className="relative grid grid-cols-2 gap-6">
          <motion.div style={{ y: y1 }} className="overflow-hidden rounded-3xl">
            <img src={IMG_1} alt="Colgante de ratán Hylasu en rincón de lectura cálido" loading="lazy" className="aspect-[3/4] w-full object-cover" />
          </motion.div>
          <motion.div style={{ y: y2 }} className="mt-14 overflow-hidden rounded-t-[999px] rounded-b-3xl">
            <img src={IMG_2} alt="Lámpara de arco cromada Hylasu con base de mármol" loading="lazy" className="aspect-[3/4] w-full object-cover" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
